export const SUPPORTED_LANGUAGES = [
  'fr-FR',
  'en-EN',
  'de-DE',
  'es-ES',
  'it-IT',
] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en-EN';
